// extracted by mini-css-extract-plugin
export default {"Results":"Results_Results__JDjfC","question":"Results_question__n8gJ6","answers":"Results_answers__CfvbB","wrapper":"Results_wrapper__I7h7l"};